import { createSelector } from "reselect";

import { GridColumnType } from "components/grid";
import { IWithAgentsState } from "store/entities/agents";
import { IWithLicensesState, selectDefaultTeamId } from "store/entities/license";
import {
  ALL_TEAMS_ID,
  ITeam,
  IWithTeamsState,
  selectCurrentAgentTeams,
  selectFirstCurrentAgentTeam,
  selectTeam,
} from "store/entities/teams";
import { IWithSessionState } from "store/features/session";

import { ISettingsViewState } from "./reducer";

export interface IWithSettingsViewState {
  views: {
    settings: ISettingsViewState;
  };
}

function getSettingsTeamId(state: IWithSettingsViewState): string {
  return state.views.settings.teamId;
}

export const getSelectedTeamId = createSelector(
  [selectCurrentAgentTeams, getSettingsTeamId, selectDefaultTeamId],
  (currentAgentTeams: ITeam[], settingsTeamId: string | null, defaultTeamId: string) => {
    const currentAgentTeamIds: string[] = currentAgentTeams.map(team => team.id);

    // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
    if (currentAgentTeamIds.includes(settingsTeamId) || settingsTeamId === ALL_TEAMS_ID) {
      return settingsTeamId;
    }

    if (currentAgentTeamIds.includes(defaultTeamId)) {
      return defaultTeamId;
    }

    return currentAgentTeamIds[0];
  }
);

export function getSelectedTeam(
  state: IWithSettingsViewState & IWithAgentsState & IWithTeamsState & IWithLicensesState & IWithSessionState
): ITeam | null {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const selectedTeamId = getSelectedTeamId(state as any);
  if (selectedTeamId === ALL_TEAMS_ID) {
    return selectFirstCurrentAgentTeam(state);
  }
  // @ts-expect-error TS(2345)
  return selectTeam(state, selectedTeamId);
}

export function getFocusedColumn(state: IWithSettingsViewState): GridColumnType {
  return state.views.settings.focusedColumn;
}

export function isUpdatingTeamNotifications(state: IWithSettingsViewState): boolean {
  return state.views.settings.isUpdatingTeamNotifications;
}

export function selectNextForwardingAddress(state: IWithSettingsViewState): string {
  return state.views.settings.nextForwardingAddress;
}
